import React, { useEffect } from "react";
import digitConverter from "../../../utils/digitConverter";
import thConverter from "../../../utils/thConverter";

const RamadanLBRow = ({ merit, student, setMyPosition, mySn, level }) => {
  useEffect(() => {
    if (student.sn === mySn) {
      setMyPosition(merit + 1);
    }
  }, [student.sn, mySn, merit, setMyPosition, level]);

  return (
    <tr className=" ">
      <th className="bg-green-100 font-bold">
        {digitConverter(merit + 1)} <sup>{thConverter(merit + 1)}</sup>
      </th>
      <th>{student?.sn}</th>
      <td>{student?.name.toUpperCase()}</td>

      {level === "1" && (
        <>
          <th>{student?.ramadan1data[0]?.Score}</th>
          <th className="bg-red-100 text-red-600">{student?.ramadan1Total}</th>
        </>
      )}
    </tr>
  );
};

export default RamadanLBRow;
